export var getScrollY = function getScrollY() {
  return window.pageYOffset;
};
export var getWidth = function getWidth() {
  return window.innerWidth;
};